"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtMoveUp = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtMoveUp = function SvgBtMoveUp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 2.5,
    stroke: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.5931 6.42985C13.7925 6.15067 14.2075 6.15067 14.4069 6.42985L17.4637 10.7094C17.7001 11.0403 17.4635 11.5 17.0568 11.5H10.9432C10.5365 11.5 10.2999 11.0403 10.5363 10.7094L13.5931 6.42985Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

exports.SvgBtMoveUp = SvgBtMoveUp;